module.exports = __webpack_public_path__ + "static/media/o13.d140a2ae.png";